import { ICalendar } from './calendar';

export interface IClasse {
  id?: string;
  nom?: string;
  calendar?: ICalendar | null;
  ecoleId?: string;
  cycleId?: string | null;
  cycleNom?: string | null;
  avecSousMatieres?: boolean | null;
  page?: number;
  size?: number;
}

export const defaultValue: Readonly<IClasse> = {
  id: null,
  nom: '',
  calendar: null,
  ecoleId: null,
  cycleId: null,
  cycleNom: null,
  page: 0,
  size: 0,
};
